export const SliderDistConstants = {
    GET_SLIDERDIST: 'GET_SLIDERDIST',
    SET_SLIDERDIST: 'SET_SLIDERDIST'
};